import React, {useEffect, useState} from 'react';
import {Link, useOutletContext, useParams, useSearchParams} from 'react-router-dom';
import TitleMain from "../../../components/Title/TitleMain";
import {useModal} from "../../../contexts/ModalContext";
import {useUser} from "../../../contexts/UserContext";
import AxiosConfig from "../../../services/AxiosConfig";
import {useBreadcrumb} from "../../../contexts/BreadcrumbContext";
import {generateBreadcrumbSegmentsAdmin} from "../../../services/BreadcrumbService";
import SeanceCreation from "../../../components/Admin/Seances/SeanceCreation";
import styles from "../Admin.module.css";
import SeanceVue from "../../../components/Admin/Seances/SeanceVue";

function AdminSeancePage() {
    const {user} = useUser();
    const {entrepriseId, contratId, activiteId, seanceId} = useParams();
    const {updateDynamicBreadcrumb} = useBreadcrumb();
    const [entreprise, setEntreprise] = useState({});
    const [contrat, setContrat] = useState({});
    const [activite, setActivite] = useState({});
    const [seance, setSeance] = useState({});
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode') || 'consultation';
    const [is404, set404] = useState(false);

    const getData = async () => {
        try {
            const response = await AxiosConfig.get(`/admin/entreprises/${entrepriseId}/contrats/${contratId}/activites/${activiteId}/seances/${seanceId}`);

            setContrat(response.data.myContrat);
            setEntreprise(response.data.myEntreprise);
            setActivite(response.data.myActivite);
            setSeance(response.data.mySeance);
        } catch (error) {
            console.error('error', error);
            if (error.response && error.response.status === 404) {
                set404(true);
            }
        }
    }

    useEffect(() => {
        if (!entrepriseId || !contratId || !activiteId || !seanceId || entrepriseId === "undefined" || contratId === "undefined" || activiteId === "undefined" || seanceId === "undefined" || entrepriseId === "" || contratId === "" || activiteId === "" || seanceId === "") {
            console.error("Erreur: Paramètres manquants");
            set404(true);
            return;
        } else {
            set404(false);
            getData();
        }
    }, [entrepriseId, contratId, activiteId, seanceId]);

    useEffect(() => {
        if (is404) return;
        updateDynamicBreadcrumb(generateBreadcrumbSegmentsAdmin({entreprise, contrat, activite, seance}));
    }, [entreprise, contrat, activite, seance]);

    if (is404) {
        console.error("Erreur: Paramètres manquants");
        return <div style={{ margin: "40px 0 0 0"}}>Erreur : séance non trouvée</div>;
    }

    return (
        mode === "creation" ?
            <SeanceCreation entreprise={entreprise} contrat={contrat} activite={activite} seance={seance}/> :
            <SeanceVue entreprise={entreprise} contrat={contrat} activite={activite} seance={seance}/>
    )
}

export default AdminSeancePage;
